var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.09,
    height: 43.09,
    viewBox: "0 0 43.09 43.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.54,43.09C9.67,43.09,0,33.42,0,21.54S9.67,0,21.54,0s21.54,9.67,21.54,21.54-9.67,21.54-21.54,21.54ZM21.54.75C10.08.75.75,10.08.75,21.54s9.33,20.79,20.79,20.79,20.79-9.33,20.79-20.79S33.01.75,21.54.75Z",
    fill: "#000",
    strokeWidth: 0
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "19.8 27.15 19.27 26.62 24.35 21.54 19.27 16.47 19.8 15.94 25.41 21.54 19.8 27.15",
    fill: "#000",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.c6aeac3b5bd6b5b5d660a6d18e288404.svg";
export { ForwardRef as ReactComponent };